<template>
  <div>
    <div style="margin-bottom: 10px">
      <el-button type="primary" @click="downLoadAll">批量下载</el-button>
    </div>
    <div style="background: #f4f7fa;width: 100%;display: flex;flex-direction: row;justify-content: space-between;align-items: center">
      <div style="padding: 15px 10px;width: 100%">
        <div class="filter-container" style="display: flex;flex-direction: row;align-items: center;flex-wrap: wrap">
          <div style="display: flex;flex-direction: row;align-items: center;margin-right: 5px">
            <div style="margin-right: 5px;font-size: 13px;width: 54px">关键字</div>
            <el-input ref="materialNo" v-model.trim="filter.materialCode" style="width: 180px" placeholder="请输入"/>
          </div>
          <div style="display: flex;flex-direction: row;align-items: center;margin-left: 10px">
            <div style="margin-right: 5px;font-size: 13px;width: 54px">文件类型</div>
            <el-select v-model.trim="filter.fileCategoryType" style="width: 180px" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.fileCategoryType)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </div>
        </div>
      </div>
      <div style="text-align: right;display: flex;flex-direction: row">
        <el-button
            type="primary"
            size="mini"
            style="padding: 8px 15px"
            :loading="handleChangeLoading"
            @click="handleChange">
          查询
        </el-button>
        <el-button type="info" size="mini" style="padding: 8px 15px" @click="handleClearClick">重置</el-button>
      </div>
    </div>
    <el-table
        v-loading="loading"
        :data="tableData"
        height="65vh"
        border
        style="width: 100%; margin-top: 5px;"
        @select="selectTest"
        @select-all="selectAll">
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="duokeMesFileName" align="center" label="文件名"/>
      <el-table-column prop="duokeMesFileModifyDatetime" align="center" label="修改时间" width="140"/>
      <el-table-column
          label="操作"
          width="120"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" :loading="downLoadLoading" @click="downLoad(scope.row)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top: 10px;font-size: 14px">总共 {{tableData.length}} 条</div>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  export default {
    name: "MESDuoke",
    components: {},
    data() {
      return {
        loading:false,
        handleChangeLoading:false,
        downLoadLoading:false,
        constant,
        tableData: [],
        idList: [],
        filter: {
          materialCode: "",
          fileCategoryType: 4,
        },
      };
    },
    methods: {
      //重置
      handleClearClick() {
        this.filter.materialCode = "";
        this.filter.fileCategoryType = "";
        this.tableData = [];
        this.idList = [];
      },
      //查询
      handleChange() {
        if (this.filter.materialCode === "") {
          return this.$message.error("物料号不可为空");
        }
        if (this.filter.fileCategoryType === "") {
          return this.$message.error("文件类型不可为空");
        }
        this.loading = true;
        this.handleChangeLoading = true;
        this.$http.get("basic","duokeMesFile/duokeMesSelect",this.filter).then((res) => {
          if (res) {
            this.tableData = res;
          }
          this.loading = false;
          this.handleChangeLoading = false;
        }).catch(() => {
          this.handleChangeLoading = false;
          this.loading = false;
          this.tableData = [];
          this.idList = [];
        });
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      //批量下载
      downLoadAll() {
        let param = {
          downloadType : "batchDownload",
        };
        this.$http.postForFile("basic","duokeMesFile/downLoadDuokeFile",this.idList,param).then(res => {
          let blob = new Blob([res.data]);
          let fileName = decodeURI("ZIP.zip");
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
          this.downLoadLoading = false;
        }).catch(() => {
          this.downLoadLoading = false;
          this.$message.error("下载失败");
        });
      },
      // 下载
      downLoad(row) {
        let list =[];
        list.push(row);
        let param = {
          downloadType : "singleDownload",
        };
        this.$http.postForFile("basic","duokeMesFile/downLoadDuokeFile",list,param).then(res => {
          let blob = new Blob([res.data]);
          let fileName = decodeURI(row.duokeMesFileName);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
          this.downLoadLoading = false;
        }).catch(() => {
          this.downLoadLoading = false;
          this.$message.error("下载失败");
        });
      },
    },
  };
</script>

<style scoped>

</style>
